import React from 'react';
import gravatar from 'gravatar';
import {Link} from 'react-router';
import {connect} from 'react-redux';

@connect(
    state => ({
        authUser: state.auth.user
    })
)
export default class UserAvatar extends React.Component {
    defaultProps = {
        useLink: true
    };
    render() {
        var {user, onClick} = this.props;
    	if (! user){
    		return null;
    	}

    	var size = this.props.size ? this.props.size : 30;    	

    	var gravatarUrl = gravatar.url(user.email, {s: size * 2, d: 'retro', r: 'x'}, true);

        var style = Object.assign({width : size + 'px', height : size + 'px'}, this.props.style);

        var clickFunc = (typeof onClick === "function") ? ( () => onClick(user) ) : ( () => {} );

        var image = (
            <img style={style}
                 onClick={clickFunc}
                 title={user.firstName + " " + user.lastName}
                 data-tip={this.props.user.firstName + " " + this.props.user.lastName}
                 src={gravatarUrl}
                 className={'avatar ' + (this.props.className ? this.props.className : '')} />
        );

        var {authUser} = this.props;

        if(authUser.email.includes('@fergusapp.com') && this.props.useLink) {
            return (<Link to={`/admin/users/${user.id}`}>{image}</Link>);
        }

        return image;
    }
}


// WEBPACK FOOTER //
// ./app/components/UserAvatar.js